var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-survey__inner c-survey__bg--green" }, [
    _c("div", { staticClass: "c-survey__content c-survey__content--padding" }, [
      _c("main", {
        staticClass: "c-survey__html",
        domProps: { innerHTML: _vm._s(_vm.pageOne.content) },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "c-survey__grid c-survey__grid--page-one" }, [
        _c(
          "div",
          { staticClass: "c-survey__page-one--cell-one" },
          [
            _c("lottie-vue-player", {
              attrs: {
                src: _vm.pageOne.animationFile,
                "player-controls": false,
                loop: true,
                autoplay: true,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "main",
          { staticClass: "c-survey__html c-survey__page-one--cell-two" },
          [
            _c("h4", { staticClass: "white-text" }, [
              _vm._v(_vm._s(_vm.pageOne.preTotalTokens)),
            ]),
            _vm._v(" "),
            _c("h1", { staticClass: "white-text" }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.settings.totalTokens) + " tokens"),
              ]),
            ]),
            _vm._v(" "),
            _c("h4", { staticClass: "white-text" }, [
              _vm._v(_vm._s(_vm.pageOne.postTotalTokens)),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "c-survey__actionbutton-row c-survey__actionbutton-row--center",
        },
        [
          _c("ActionButton", {
            attrs: {
              title: _vm.pageOne.prevLabel,
              buttonAction: "prev",
              arrowUp: true,
              muted: true,
            },
          }),
          _vm._v(" "),
          _c("ActionButton", {
            attrs: { title: _vm.pageOne.nextLabel, buttonAction: "next" },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-survey__content-img" }, [
      _c(
        "svg",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 2288.08 476.67",
          },
        },
        [
          _c("g", { staticStyle: { isolation: "isolate" } }, [
            _c("g", { attrs: { id: "Layer_2" } }, [
              _c("g", { attrs: { id: "Layer_1-2" } }, [
                _c("rect", {
                  staticStyle: { fill: "#1fcc8a", "stroke-width": "0px" },
                  attrs: { y: "204.82", width: "2288.08", height: "271.85" },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "296.86 315.37 190.22 315.37 190.22 164.21 243.54 96.84 296.86 164.21 296.86 315.37",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fdb930", "stroke-width": "0px" },
                  attrs: {
                    x: "296.86",
                    y: "164.21",
                    width: "275.51",
                    height: "151.16",
                  },
                }),
                _c("g", { staticStyle: { opacity: ".29" } }, [
                  _c("rect", {
                    staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                    attrs: {
                      x: "190.22",
                      y: "295.5",
                      width: "382.15",
                      height: "19.87",
                    },
                  }),
                ]),
                _c("g", { staticStyle: { opacity: ".29" } }, [
                  _c("path", {
                    staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                    attrs: {
                      d: "m241.36,202.97h4.36c17.7,0,32.06,14.37,32.06,32.06v60.47h-68.48v-60.47c0-17.7,14.37-32.06,32.06-32.06Z",
                    },
                  }),
                ]),
                _c("path", {
                  staticStyle: { fill: "#2393ff", "stroke-width": "0px" },
                  attrs: {
                    d: "m289.02,237.21v58.29h-68.48v-58.29c0-1.32.08-2.63.23-3.92,1.83-16.08,14.8-28.78,31.01-30.19.99-.1,1.99-.14,3.01-.14s2.01.04,3,.14c.18.01.37.03.55.05,4.9.5,9.5,2.03,13.56,4.39,1.77,1.02,3.44,2.19,4.99,3.5.73.62,1.43,1.27,2.11,1.95,1.51,1.51,2.88,3.16,4.08,4.93,3.06,4.48,5.08,9.71,5.72,15.37.15,1.28.23,2.59.23,3.92Z",
                  },
                }),
                _c("g", { staticStyle: { opacity: ".3" } }, [
                  _c("path", {
                    staticStyle: { fill: "#fff", "stroke-width": "0px" },
                    attrs: {
                      d: "m271.9,207.54l-51.36,51.36v-17.95l37.8-37.8c4.9.5,9.5,2.03,13.56,4.39Z",
                    },
                  }),
                  _c("path", {
                    staticStyle: { fill: "#fff", "stroke-width": "0px" },
                    attrs: {
                      d: "m283.08,217.92l-62.54,62.55v-13.07l56.35-56.35c.73.62,1.43,1.27,2.11,1.95,1.51,1.51,2.88,3.16,4.08,4.93Z",
                    },
                  }),
                ]),
                _c("path", {
                  staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                  attrs: {
                    d: "m289.02,239.3v-2.09c0-1.32-.08-2.63-.23-3.92h-31.01v-30.19c-.99-.1-1.99-.14-3-.14s-2.02.04-3.01.14v30.19h-31.01c-.15,1.28-.23,2.59-.23,3.92v2.09h31.23v25.1h-31.23v6.01h31.23v25.09h6.01v-25.09h31.24v-6.01h-31.24v-25.1h31.24Z",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#754dc1", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "572.37 158.01 291.59 158.01 238.84 89.52 519.62 89.52 572.37 158.01",
                  },
                }),
                _c("g", { staticStyle: { opacity: ".54" } }, [
                  _c("polygon", {
                    staticStyle: { fill: "#5f28b5", "stroke-width": "0px" },
                    attrs: {
                      points:
                        "418.15 122.23 391.74 122.23 386.78 115.79 413.19 115.79 418.15 122.23",
                    },
                  }),
                ]),
                _c("g", { staticStyle: { opacity: ".54" } }, [
                  _c("polygon", {
                    staticStyle: { fill: "#5f28b5", "stroke-width": "0px" },
                    attrs: {
                      points:
                        "343.49 130.2 317.09 130.2 312.13 123.76 338.53 123.76 343.49 130.2",
                    },
                  }),
                ]),
                _c("g", { staticStyle: { opacity: ".54" } }, [
                  _c("polygon", {
                    staticStyle: { fill: "#5f28b5", "stroke-width": "0px" },
                    attrs: {
                      points:
                        "381.29 109.31 354.89 109.31 349.93 102.87 376.33 102.87 381.29 109.31",
                    },
                  }),
                ]),
                _c("g", { staticStyle: { opacity: ".54" } }, [
                  _c("polygon", {
                    staticStyle: { fill: "#5f28b5", "stroke-width": "0px" },
                    attrs: {
                      points:
                        "525.93 142.24 499.52 142.24 494.56 135.79 520.97 135.79 525.93 142.24",
                    },
                  }),
                ]),
                _c("g", { staticStyle: { opacity: ".54" } }, [
                  _c("polygon", {
                    staticStyle: { fill: "#5f28b5", "stroke-width": "0px" },
                    attrs: {
                      points:
                        "536.65 130.2 510.24 130.2 505.28 123.76 531.69 123.76 536.65 130.2",
                    },
                  }),
                ]),
                _c("g", { staticStyle: { opacity: ".54" } }, [
                  _c("polygon", {
                    staticStyle: { fill: "#5f28b5", "stroke-width": "0px" },
                    attrs: {
                      points:
                        "499.7 130.2 473.3 130.2 468.34 123.76 494.74 123.76 499.7 130.2",
                    },
                  }),
                ]),
                _c("g", { staticStyle: { opacity: ".54" } }, [
                  _c("polygon", {
                    staticStyle: { fill: "#5f28b5", "stroke-width": "0px" },
                    attrs: {
                      points:
                        "499.7 106.09 473.3 106.09 468.34 99.65 494.74 99.65 499.7 106.09",
                    },
                  }),
                ]),
                _c("path", {
                  staticStyle: { fill: "#5f28b5", "stroke-width": "0px" },
                  attrs: {
                    d: "m190.21,170.02c-2,0-4-.67-5.66-2.04-3.77-3.13-4.29-8.72-1.17-12.49l53.32-64.3c1.69-2.03,4.19-3.21,6.83-3.21s5.14,1.18,6.83,3.21l50.66,61.09h271.34c4.9,0,8.87,3.97,8.87,8.87s-3.97,8.87-8.87,8.87h-275.51c-2.64,0-5.14-1.18-6.83-3.21l-46.49-56.07-46.49,56.07c-1.75,2.12-4.29,3.21-6.83,3.21Z",
                  },
                }),
                _c("g", { staticStyle: { opacity: ".24" } }, [
                  _c("path", {
                    staticStyle: { fill: "#fff", "stroke-width": "0px" },
                    attrs: {
                      d: "m339.76,144.62h-34.01c-.72,0-1.41-.33-1.86-.89l-21.26-26.49c-.83-1.03-.66-2.53.37-3.36,1.03-.83,2.53-.66,3.36.37l20.54,25.59h32.86c1.32,0,2.39,1.07,2.39,2.39s-1.07,2.39-2.39,2.39Z",
                    },
                  }),
                ]),
                _c("rect", {
                  staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                  attrs: {
                    x: "404.03",
                    y: "295.5",
                    width: "48.62",
                    height: "9.93",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                  attrs: {
                    x: "404.03",
                    y: "305.43",
                    width: "64.3",
                    height: "9.93",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ffcf83", "stroke-width": "0px" },
                  attrs: {
                    x: "452.65",
                    y: "295.5",
                    width: "48.62",
                    height: "9.93",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fdb930", "stroke-width": "0px" },
                  attrs: {
                    x: "468.34",
                    y: "305.43",
                    width: "48.62",
                    height: "9.93",
                  },
                }),
                _c("g", { staticStyle: { opacity: ".29" } }, [
                  _c("path", {
                    staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                    attrs: {
                      d: "m438.62,190.42h3.56c14.44,0,26.16,11.72,26.16,26.16v78.92h-55.88v-78.92c0-14.44,11.72-26.16,26.16-26.16Z",
                    },
                  }),
                ]),
                _c("path", {
                  staticStyle: { fill: "#754dc1", "stroke-width": "0px" },
                  attrs: {
                    d: "m430.2,190.42h3.56c14.44,0,26.16,11.72,26.16,26.16v78.92h-55.88v-78.92c0-14.44,11.72-26.16,26.16-26.16Z",
                  },
                }),
                _c("circle", {
                  staticStyle: { fill: "#262e6c", "stroke-width": "0px" },
                  attrs: { cx: "448.47", cy: "249.94", r: "4.18" },
                }),
                _c("g", { staticStyle: { opacity: ".29" } }, [
                  _c("rect", {
                    staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                    attrs: {
                      x: "321.01",
                      y: "211.05",
                      width: "72.04",
                      height: "55.18",
                    },
                  }),
                ]),
                _c("rect", {
                  staticStyle: { fill: "#2393ff", "stroke-width": "0px" },
                  attrs: {
                    x: "312.13",
                    y: "211.05",
                    width: "72.04",
                    height: "55.18",
                  },
                }),
                _c("g", { staticStyle: { opacity: ".3" } }, [
                  _c("polygon", {
                    staticStyle: { fill: "#fff", "stroke-width": "0px" },
                    attrs: {
                      points:
                        "378.54 211.05 323.36 266.22 312.13 266.22 312.13 250.84 351.92 211.05 378.54 211.05",
                    },
                  }),
                  _c("polygon", {
                    staticStyle: { fill: "#fff", "stroke-width": "0px" },
                    attrs: {
                      points:
                        "384.17 216.64 384.17 233.53 351.47 266.22 334.58 266.22 384.17 216.64",
                    },
                  }),
                ]),
                _c("rect", {
                  staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                  attrs: {
                    x: "343.54",
                    y: "211.05",
                    width: "5.97",
                    height: "55.18",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                  attrs: {
                    x: "312.13",
                    y: "231.03",
                    width: "72.04",
                    height: "5.98",
                  },
                }),
                _c("g", { staticStyle: { opacity: ".29" } }, [
                  _c("rect", {
                    staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                    attrs: {
                      x: "489.38",
                      y: "211.05",
                      width: "72.04",
                      height: "55.18",
                    },
                  }),
                ]),
                _c("rect", {
                  staticStyle: { fill: "#2393ff", "stroke-width": "0px" },
                  attrs: {
                    x: "480.5",
                    y: "211.05",
                    width: "72.04",
                    height: "55.18",
                  },
                }),
                _c("g", { staticStyle: { opacity: ".3" } }, [
                  _c("polygon", {
                    staticStyle: { fill: "#fff", "stroke-width": "0px" },
                    attrs: {
                      points:
                        "546.91 211.05 491.73 266.22 480.5 266.22 480.5 250.84 520.29 211.05 546.91 211.05",
                    },
                  }),
                  _c("polygon", {
                    staticStyle: { fill: "#fff", "stroke-width": "0px" },
                    attrs: {
                      points:
                        "552.54 216.64 552.54 233.53 519.85 266.22 502.95 266.22 552.54 216.64",
                    },
                  }),
                ]),
                _c("rect", {
                  staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                  attrs: {
                    x: "511.92",
                    y: "211.05",
                    width: "5.97",
                    height: "55.18",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                  attrs: {
                    x: "480.5",
                    y: "231.03",
                    width: "72.04",
                    height: "5.98",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "349.52",
                    y: "185.89",
                    width: "17.4",
                    height: "7.67",
                  },
                }),
                _c("g", { staticStyle: { opacity: ".29" } }, [
                  _c("rect", {
                    staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                    attrs: {
                      x: "243.11",
                      y: "174.25",
                      width: "17.4",
                      height: "7.67",
                    },
                  }),
                ]),
                _c("g", { staticStyle: { opacity: ".29" } }, [
                  _c("rect", {
                    staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                    attrs: {
                      x: "283.09",
                      y: "190.42",
                      width: "13.23",
                      height: "6.97",
                    },
                  }),
                ]),
                _c("g", { staticStyle: { opacity: ".29" } }, [
                  _c("rect", {
                    staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                    attrs: {
                      x: "190.22",
                      y: "258.9",
                      width: "13.23",
                      height: "6.97",
                    },
                  }),
                ]),
                _c("g", { staticStyle: { opacity: ".29" } }, [
                  _c("rect", {
                    staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                    attrs: {
                      x: "203.14",
                      y: "186.58",
                      width: "17.4",
                      height: "7.67",
                    },
                  }),
                ]),
                _c("g", { staticStyle: { opacity: ".29" } }, [
                  _c("rect", {
                    staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                    attrs: {
                      x: "228.82",
                      y: "161.14",
                      width: "17.4",
                      height: "7.67",
                    },
                  }),
                ]),
                _c("g", { staticStyle: { opacity: ".29" } }, [
                  _c("rect", {
                    staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                    attrs: {
                      x: "246.08",
                      y: "145.46",
                      width: "17.4",
                      height: "7.67",
                    },
                  }),
                ]),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "363.89",
                    y: "195.49",
                    width: "17.4",
                    height: "7.67",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "500.16",
                    y: "174.25",
                    width: "17.4",
                    height: "7.67",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "489.38",
                    y: "185.89",
                    width: "17.4",
                    height: "7.67",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "476.96",
                    y: "280.46",
                    width: "15.68",
                    height: "7.67",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "382.1",
                    y: "276.63",
                    width: "15.68",
                    height: "7.67",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "363.89",
                    y: "284.3",
                    width: "15.68",
                    height: "7.67",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "561.43",
                    y: "195.3",
                    width: "10.94",
                    height: "7.67",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "296.86",
                    y: "269.88",
                    width: "10.94",
                    height: "7.67",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#04b776", "stroke-width": "0px" },
                  attrs: {
                    d: "m620.02,311.11c.21-7.34-3.34-14.66-8.92-18.41-5.58-3.75-12.96-3.76-18.55-.04.29-8.86-5.92-17.39-13.66-18.76-7.74-1.37-15.96,4.6-18.08,13.13-11.44-.95-22.3,11.31-21.49,24.26-5.09-3.33-12.25-1.76-15.88,3.48-2.39,3.46-3.03,8.23-2.02,12.45l121.9,2.34c-5.84-7.64-14.4-17.74-23.31-18.46Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#108457", "stroke-width": "0px" },
                  attrs: {
                    d: "m570.89,288.9c.75,0,1.48-.66,1.44-1.44s-.63-1.44-1.44-1.44c-.75,0-1.48.66-1.44,1.44s.63,1.44,1.44,1.44h0Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#108457", "stroke-width": "0px" },
                  attrs: {
                    d: "m549.31,311.47c.75,0,1.48-.66,1.44-1.44s-.63-1.44-1.44-1.44c-.75,0-1.48.66-1.44,1.44s.63,1.44,1.44,1.44h0Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#108457", "stroke-width": "0px" },
                  attrs: {
                    d: "m565.01,302.15c.75,0,1.48-.66,1.44-1.44s-.63-1.44-1.44-1.44c-.75,0-1.48.66-1.44,1.44s.63,1.44,1.44,1.44h0Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#108457", "stroke-width": "0px" },
                  attrs: {
                    d: "m570.4,311.96c.75,0,1.48-.66,1.44-1.44s-.63-1.44-1.44-1.44c-.75,0-1.48.66-1.44,1.44s.63,1.44,1.44,1.44h0Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#108457", "stroke-width": "0px" },
                  attrs: {
                    d: "m605.73,303.13c.75,0,1.48-.66,1.44-1.44s-.63-1.44-1.44-1.44c-.75,0-1.48.66-1.44,1.44s.63,1.44,1.44,1.44h0Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#108457", "stroke-width": "0px" },
                  attrs: {
                    d: "m601.8,312.45c.75,0,1.48-.66,1.44-1.44s-.63-1.44-1.44-1.44c-.75,0-1.48.66-1.44,1.44s.63,1.44,1.44,1.44h0Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#108457", "stroke-width": "0px" },
                  attrs: {
                    d: "m612.11,318.34c.75,0,1.48-.66,1.44-1.44s-.63-1.44-1.44-1.44c-.75,0-1.48.66-1.44,1.44s.63,1.44,1.44,1.44h0Z",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#7f5ed3", "stroke-width": "0px" },
                  attrs: {
                    x: "1311.43",
                    y: "114.95",
                    width: "147.07",
                    height: "203.02",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#693cbf", "stroke-width": "0px" },
                  attrs: {
                    x: "1458.51",
                    y: "114.95",
                    width: "216.86",
                    height: "203.02",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#846ae2", "stroke-width": "0px" },
                  attrs: {
                    x: "1311.43",
                    y: "114.95",
                    width: "147.07",
                    height: "101.51",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#7f5ed3", "stroke-width": "0px" },
                  attrs: {
                    x: "1458.79",
                    y: "114.95",
                    width: "216.86",
                    height: "101.51",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#f97432", "stroke-width": "0px" },
                  attrs: {
                    x: "1327.58",
                    y: "229.15",
                    width: "114.2",
                    height: "88.82",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#f98d5d", "stroke-width": "0px" },
                  attrs: {
                    x: "1327.58",
                    y: "241.51",
                    width: "114.2",
                    height: "2.31",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#f98d5d", "stroke-width": "0px" },
                  attrs: {
                    x: "1327.58",
                    y: "315.66",
                    width: "114.2",
                    height: "2.31",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#f98d5d", "stroke-width": "0px" },
                  attrs: {
                    x: "1327.58",
                    y: "303.31",
                    width: "114.2",
                    height: "2.31",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#f98d5d", "stroke-width": "0px" },
                  attrs: {
                    x: "1327.58",
                    y: "290.95",
                    width: "114.2",
                    height: "2.31",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#f98d5d", "stroke-width": "0px" },
                  attrs: {
                    x: "1327.58",
                    y: "278.59",
                    width: "114.2",
                    height: "2.31",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#f98d5d", "stroke-width": "0px" },
                  attrs: {
                    x: "1327.58",
                    y: "266.23",
                    width: "114.2",
                    height: "2.31",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#f98d5d", "stroke-width": "0px" },
                  attrs: {
                    x: "1327.58",
                    y: "253.87",
                    width: "114.2",
                    height: "2.31",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#f98d5d", "stroke-width": "0px" },
                  attrs: {
                    x: "1327.58",
                    y: "229.15",
                    width: "114.2",
                    height: "2.31",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    x: "1301.63",
                    y: "114.38",
                    width: "167.26",
                    height: "6.92",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    x: "1468.89",
                    y: "114.38",
                    width: "214.55",
                    height: "6.92",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#f1e3ff", "stroke-width": "0px" },
                  attrs: {
                    x: "1327.58",
                    y: "135.14",
                    width: "114.2",
                    height: "49.02",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#f1e3ff", "stroke-width": "0px" },
                  attrs: {
                    x: "1473.5",
                    y: "135.14",
                    width: "114.2",
                    height: "49.02",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#2393ff", "stroke-width": "0px" },
                  attrs: {
                    x: "1479.27",
                    y: "139.18",
                    width: "102.66",
                    height: "40.95",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#b36beb", "stroke-width": "0px" },
                  attrs: {
                    x: "1323.54",
                    y: "184.16",
                    width: "122.27",
                    height: "4.61",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#2393ff", "stroke-width": "0px" },
                  attrs: {
                    x: "1331.62",
                    y: "139.18",
                    width: "24.22",
                    height: "18.46",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#2393ff", "stroke-width": "0px" },
                  attrs: {
                    x: "1331.62",
                    y: "161.67",
                    width: "24.22",
                    height: "18.46",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#2393ff", "stroke-width": "0px" },
                  attrs: {
                    x: "1359.88",
                    y: "139.18",
                    width: "48.45",
                    height: "40.95",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#5f28b5", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "1566.94 216.46 1458.51 216.46 1458.51 317.97 1552.52 317.97 1566.94 317.97 1675.37 317.97 1675.37 300.09 1566.94 216.46",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    d: "m1595.16,216.47l-15-11.65-13.22-10.27h-108.43v21.92h108.43l23.93,18.46,5.19,4,20.77,16.02,4.69,3.62,21.84,16.84,5.19,4,26.82,20.69v-21.34l-80.21-62.29Zm75.02,73.07l-21.63-16.68-5.19-4.01-21.34-16.45-5.19-4.01-20.77-16.02-5.19-4-15.43-11.9-5.33-4.11-.29-.22-1.11-.86h-105.01v-11.54h101.46l.62.48,2.31,1.8,1.73,1.34,1.88,1.46,15,11.65,4.17,3.24,5.19,4.03,20.77,16.13,5.19,4.03,21.87,16.98,4.66,3.62,21.63,16.8v8.24Z",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#f97432", "stroke-width": "0px" },
                  attrs: {
                    x: "1565.78",
                    y: "196.85",
                    width: "2.31",
                    height: "19.61",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    x: "1537.67",
                    y: "196.85",
                    width: "5.19",
                    height: "19.61",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    x: "1564.63",
                    y: "196.85",
                    width: "5.19",
                    height: "19.61",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    x: "1590.87",
                    y: "219.35",
                    width: "5.19",
                    height: "19.61",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    x: "1616.83",
                    y: "238.96",
                    width: "5.19",
                    height: "19.61",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    x: "1643.36",
                    y: "260.87",
                    width: "5.19",
                    height: "19.61",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    x: "1510.99",
                    y: "196.85",
                    width: "5.19",
                    height: "19.61",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    x: "1484.32",
                    y: "196.85",
                    width: "5.19",
                    height: "19.61",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#d8567e", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "1385.26 87.27 1603.85 87.27 1677.67 114.95 1384.1 114.95 1385.26 87.27",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3426f", "stroke-width": "0px" },
                  attrs: {
                    d: "m1311.43,114.95c2.88-.58,73.82-27.68,73.82-27.68l73.25,27.68h-147.07Z",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    "mix-blend-mode": "multiply",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1675.37 127.57 1311.43 127.57 1311.11 121.43 1678.53 120.61 1675.37 127.57",
                  },
                }),
                _c("rect", {
                  staticStyle: {
                    "mix-blend-mode": "multiply",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    x: "1323.54",
                    y: "188.2",
                    width: "122.27",
                    height: "5.77",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    "mix-blend-mode": "multiply",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1441.78 229.15 1334.5 229.15 1327.58 229.15 1327.58 236.07 1327.58 317.97 1334.5 317.97 1334.5 236.07 1441.78 236.07 1441.78 229.15",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#fff",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1379.86 180.13 1374.67 180.13 1365.85 139.18 1371.04 139.18 1379.86 180.13",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#fff",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1385.63 180.13 1382.75 180.13 1373.93 139.18 1376.81 139.18 1385.63 180.13",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#fff",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1509.34 180.13 1500.98 180.13 1486.77 139.18 1495.13 139.18 1509.34 180.13",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#fff",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1524.26 180.13 1518.79 180.13 1502.07 139.18 1507.54 139.18 1524.26 180.13",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#fff",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1343.53 157.63 1338.34 157.63 1334.13 139.18 1339.32 139.18 1343.53 157.63",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#fff",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1349.29 157.63 1346.41 157.63 1342.21 139.18 1345.09 139.18 1349.29 157.63",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#fff",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1343.53 180.13 1338.34 180.13 1334.13 161.67 1339.32 161.67 1343.53 180.13",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#fff",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1349.29 180.13 1346.41 180.13 1342.21 161.67 1345.09 161.67 1349.29 180.13",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#f1e3ff", "stroke-width": "0px" },
                  attrs: {
                    x: "1626.34",
                    y: "135.14",
                    width: "36.91",
                    height: "49.02",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#2393ff", "stroke-width": "0px" },
                  attrs: {
                    x: "1412.37",
                    y: "139.18",
                    width: "24.22",
                    height: "18.46",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#2393ff", "stroke-width": "0px" },
                  attrs: {
                    x: "1412.37",
                    y: "161.67",
                    width: "24.22",
                    height: "18.46",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#fff",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1423.7 157.63 1418.51 157.63 1414.3 139.18 1419.49 139.18 1423.7 157.63",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#fff",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1429.46 157.63 1426.58 157.63 1422.37 139.18 1425.26 139.18 1429.46 157.63",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#fff",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1423.7 180.13 1418.51 180.13 1414.3 161.67 1419.49 161.67 1423.7 180.13",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#fff",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1429.46 180.13 1426.58 180.13 1422.37 161.67 1425.26 161.67 1429.46 180.13",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#2393ff", "stroke-width": "0px" },
                  attrs: {
                    x: "1632.69",
                    y: "139.18",
                    width: "24.22",
                    height: "18.46",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#2393ff", "stroke-width": "0px" },
                  attrs: {
                    x: "1632.67",
                    y: "161.69",
                    width: "24.26",
                    height: "18.41",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#fff",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1644.02 157.63 1638.83 157.63 1634.62 139.18 1639.81 139.18 1644.02 157.63",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#fff",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1649.79 157.63 1646.9 157.63 1642.7 139.18 1645.58 139.18 1649.79 157.63",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#fff",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1644.02 180.13 1638.83 180.13 1634.62 161.67 1639.81 161.67 1644.02 180.13",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#fff",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1649.79 180.13 1646.9 180.13 1642.7 161.67 1645.58 161.67 1649.79 180.13",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fca37b", "stroke-width": "0px" },
                  attrs: {
                    x: "1376.61",
                    y: "308.74",
                    width: "13.27",
                    height: "2.31",
                  },
                }),
                _c("rect", {
                  staticStyle: {
                    "mix-blend-mode": "multiply",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    x: "1458.06",
                    y: "300.59",
                    width: "217.3",
                    height: "17.38",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "864.03 105.38 834.29 105.38 910.37 169.13 934.62 169.13 1025.97 169.13 957.7 169.13 957.7 158.92 864.03 105.38",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#d3426f", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "742.94 169.13 742.94 159.06 834.29 105.38 927.97 158.92 927.97 169.13 742.94 169.13",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#fdb930", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "910.37 169.13 910.37 319.33 760.54 319.33 760.54 169.13 773.6 161.45 779.58 157.93 803.47 143.91 809.45 140.39 834.41 125.73 860.07 140.39 866.23 143.91 890.78 157.93 896.94 161.45 910.37 169.13",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "760.54",
                    y: "175.47",
                    width: "148.64",
                    height: "3.52",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "890.78 157.93 779.58 157.93 773.6 161.45 896.94 161.45 890.78 157.93",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "866.23 143.91 803.47 143.91 809.45 140.39 860.07 140.39 866.23 143.91",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "760.54",
                    y: "193.01",
                    width: "148.64",
                    height: "3.52",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "760.54",
                    y: "210.55",
                    width: "148.64",
                    height: "3.52",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "760.54",
                    y: "228.1",
                    width: "148.64",
                    height: "3.52",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "760.54",
                    y: "245.64",
                    width: "148.64",
                    height: "3.52",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "760.54",
                    y: "263.18",
                    width: "148.64",
                    height: "3.52",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "760.54",
                    y: "280.72",
                    width: "148.64",
                    height: "3.52",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "760.54",
                    y: "298.26",
                    width: "148.64",
                    height: "3.52",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "760.54",
                    y: "315.8",
                    width: "148.64",
                    height: "3.52",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "909.18",
                    y: "169.13",
                    width: "211.75",
                    height: "150.19",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#fff", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "768.4 319.32 760.54 319.32 760.54 169.13 768.4 164.52 768.4 319.32",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#fff", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "901.33 319.32 909.18 319.32 909.18 169.13 901.33 164.52 901.33 319.32",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                  attrs: {
                    x: "801.14",
                    y: "184.39",
                    width: "68.64",
                    height: "93.28",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                  attrs: {
                    x: "801.14",
                    y: "184.39",
                    width: "5.98",
                    height: "93.28",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#2393ff", "stroke-width": "0px" },
                  attrs: {
                    x: "809.94",
                    y: "193.19",
                    width: "22.53",
                    height: "75.69",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#2393ff", "stroke-width": "0px" },
                  attrs: {
                    x: "838.45",
                    y: "193.19",
                    width: "22.53",
                    height: "75.69",
                  },
                }),
                _c("circle", {
                  staticStyle: { fill: "#d3426f", "stroke-width": "0px" },
                  attrs: { cx: "835.26", cy: "104.03", r: "8.23" },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea7b44", "stroke-width": "0px" },
                  attrs: {
                    x: "909.18",
                    y: "173.71",
                    width: "210.46",
                    height: "3.52",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea7b44", "stroke-width": "0px" },
                  attrs: {
                    x: "909.18",
                    y: "191.25",
                    width: "210.46",
                    height: "3.52",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea7b44", "stroke-width": "0px" },
                  attrs: {
                    x: "909.18",
                    y: "208.79",
                    width: "210.46",
                    height: "3.52",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea7b44", "stroke-width": "0px" },
                  attrs: {
                    x: "909.18",
                    y: "226.34",
                    width: "210.46",
                    height: "3.52",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea7b44", "stroke-width": "0px" },
                  attrs: {
                    x: "909.18",
                    y: "243.88",
                    width: "210.46",
                    height: "3.52",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea7b44", "stroke-width": "0px" },
                  attrs: {
                    x: "909.18",
                    y: "261.42",
                    width: "210.46",
                    height: "3.52",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea7b44", "stroke-width": "0px" },
                  attrs: {
                    x: "909.18",
                    y: "278.96",
                    width: "210.46",
                    height: "3.52",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea7b44", "stroke-width": "0px" },
                  attrs: {
                    x: "909.18",
                    y: "296.5",
                    width: "210.46",
                    height: "3.52",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea7b44", "stroke-width": "0px" },
                  attrs: {
                    x: "909.18",
                    y: "314.04",
                    width: "210.46",
                    height: "3.52",
                  },
                }),
                _c("circle", {
                  staticStyle: { fill: "#d3426f", "stroke-width": "0px" },
                  attrs: { cx: "835.27", cy: "92.01", r: "4.12" },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    x: "957.7",
                    y: "158.92",
                    width: "174.43",
                    height: "10.21",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "1054.79",
                    y: "49.45",
                    width: "37.75",
                    height: "24.74",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fdb930", "stroke-width": "0px" },
                  attrs: {
                    x: "1052.35",
                    y: "71.75",
                    width: "42.24",
                    height: "53.98",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "1059.74",
                    y: "37.59",
                    width: "11.86",
                    height: "11.86",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "1075.73",
                    y: "37.59",
                    width: "11.86",
                    height: "11.86",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "1078",
                    y: "77.61",
                    width: "12.48",
                    height: "7.63",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "1067.42",
                    y: "88.19",
                    width: "12.48",
                    height: "7.63",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "1081.35",
                    y: "100.22",
                    width: "12.48",
                    height: "7.63",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "1053.5",
                    y: "77.61",
                    width: "7.63",
                    height: "7.63",
                  },
                }),
                _c("rect", {
                  staticStyle: {
                    fill: "#ce641d",
                    opacity: ".29",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    x: "1059.74",
                    y: "37.59",
                    width: "11.86",
                    height: "11.86",
                  },
                }),
                _c("rect", {
                  staticStyle: {
                    fill: "#ce641d",
                    opacity: ".29",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    x: "1075.73",
                    y: "37.59",
                    width: "11.86",
                    height: "11.86",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                  attrs: {
                    x: "1077.6",
                    y: "184.39",
                    width: "38.53",
                    height: "93.28",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#2393ff", "stroke-width": "0px" },
                  attrs: {
                    x: "1086.4",
                    y: "193.19",
                    width: "20.93",
                    height: "75.69",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#efefef",
                    opacity: ".3",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1107.33 193.19 1107.33 212.11 1086.4 233.04 1086.4 201.6 1094.81 193.19 1107.33 193.19",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#efefef",
                    opacity: ".3",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "1107.33 229.97 1107.33 246.92 1086.4 267.86 1086.4 250.9 1107.33 229.97",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                  attrs: {
                    x: "1093.87",
                    y: "209.61",
                    width: "5.98",
                    height: "36.97",
                    transform: "translate(1324.96 -868.77) rotate(90)",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#d8567e", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "864.03 105.38 1001.93 63.53 1001.93 158.92 957.7 158.92 864.03 105.38",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#d3426f", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "1001.93 63.53 1120.58 137.26 1121.29 158.92 1001.93 158.92 1001.93 63.53",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    x: "987.69",
                    y: "296.5",
                    width: "123.28",
                    height: "22.82",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                  attrs: {
                    x: "1001.93",
                    y: "208.79",
                    width: "53.94",
                    height: "87.71",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    x: "989.44",
                    y: "238.88",
                    width: "78.91",
                    height: "36.34",
                    transform: "translate(1285.94 -771.85) rotate(90)",
                  },
                }),
                _c("circle", {
                  staticStyle: { fill: "#262e6c", "stroke-width": "0px" },
                  attrs: { cx: "1041.05", cy: "258.37", r: "2.2" },
                }),
                _c("rect", {
                  staticStyle: {
                    "mix-blend-mode": "multiply",
                    opacity: ".1",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    x: "977.37",
                    y: "178.96",
                    width: "143.92",
                    height: "140.39",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#efefef", "stroke-width": "0px" },
                  attrs: {
                    x: "977.37",
                    y: "178.99",
                    width: "10.32",
                    height: "140.33",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#efefef", "stroke-width": "0px" },
                  attrs: {
                    x: "1110.97",
                    y: "178.99",
                    width: "10.32",
                    height: "140.33",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#efefef", "stroke-width": "0px" },
                  attrs: {
                    x: "977.37",
                    y: "178.93",
                    width: "142.27",
                    height: "10.44",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#efefef", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "1007.76 178.99 977.37 226.34 977.37 178.93 1007.76 178.99",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#efefef", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "1090.1 178.99 1120.48 226.34 1120.48 178.93 1090.1 178.99",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                  attrs: {
                    x: "919.17",
                    y: "184.39",
                    width: "38.53",
                    height: "93.28",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#2393ff", "stroke-width": "0px" },
                  attrs: {
                    x: "927.97",
                    y: "193.19",
                    width: "20.93",
                    height: "75.69",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#efefef",
                    opacity: ".3",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "948.9 193.19 948.9 210.58 927.97 231.5 927.97 200.06 934.85 193.19 948.9 193.19",
                  },
                }),
                _c("polygon", {
                  staticStyle: {
                    fill: "#efefef",
                    opacity: ".3",
                    "stroke-width": "0px",
                  },
                  attrs: {
                    points:
                      "948.9 228.43 948.9 245.39 927.97 266.32 927.97 249.37 948.9 228.43",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ce641d", "stroke-width": "0px" },
                  attrs: {
                    x: "935.45",
                    y: "209.61",
                    width: "5.98",
                    height: "36.97",
                    transform: "translate(1166.53 -710.34) rotate(90)",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#d3426f", "stroke-width": "0px" },
                  attrs: {
                    x: "990.03",
                    y: "81.19",
                    width: "4.4",
                    height: "48.38",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    x: "1018.03",
                    y: "95.29",
                    width: "4.4",
                    height: "48.38",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    x: "1028.9",
                    y: "88.88",
                    width: "4.4",
                    height: "48.38",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    x: "1044.87",
                    y: "101.54",
                    width: "4.4",
                    height: "48.38",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#d3426f", "stroke-width": "0px" },
                  attrs: {
                    x: "980.33",
                    y: "95.29",
                    width: "4.4",
                    height: "48.38",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#d3426f", "stroke-width": "0px" },
                  attrs: {
                    x: "967.15",
                    y: "88.07",
                    width: "4.4",
                    height: "48.38",
                  },
                }),
                _c("g", { staticStyle: { opacity: ".3" } }, [
                  _c("polygon", {
                    staticStyle: { fill: "#efefef", "stroke-width": "0px" },
                    attrs: {
                      points:
                        "832.46 193.19 832.46 222.61 809.94 245.13 809.94 213.69 830.44 193.19 832.46 193.19",
                    },
                  }),
                  _c("polygon", {
                    staticStyle: { fill: "#efefef", "stroke-width": "0px" },
                    attrs: {
                      points:
                        "860.97 193.19 860.97 194.09 838.45 216.62 838.45 193.19 860.97 193.19",
                    },
                  }),
                  _c("polygon", {
                    staticStyle: { fill: "#efefef", "stroke-width": "0px" },
                    attrs: {
                      points:
                        "809.94 262.99 832.46 240.46 832.46 257.42 821.01 268.87 809.94 268.87 809.94 262.99",
                    },
                  }),
                  _c("polygon", {
                    staticStyle: { fill: "#efefef", "stroke-width": "0px" },
                    attrs: {
                      points:
                        "860.97 211.95 860.97 228.91 838.45 251.44 838.45 234.48 860.97 211.95",
                    },
                  }),
                ]),
                _c("path", {
                  staticStyle: { fill: "#37cfc3", "stroke-width": "0px" },
                  attrs: {
                    d: "m810.76,321.03c-1.16-6.85-5.22-12.57-10.12-14.26-4.9-1.69-10.41.75-13.72,6.06-.92-8.8-5.3-16.75-11.16-20.25-5.86-3.51-13.01-2.46-18.22,2.68-3.8-6.62-10.5-9.7-16.37-7.52-5.87,2.18-10.59,9.5-11.52,17.87-4.42-5.94-11.71-7.2-17.04-2.96-5.33,4.24-8.26,13.63-6.84,21.96-7.08-8.88-14.71-2.31-17.76,7.46h145.07c-3.38-11.44-14.52-17.07-22.32-11.03Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#2a7a84", "stroke-width": "0px" },
                  attrs: {
                    d: "m787.09,325.94c1.57-2.21,4.43-3.43,7.11-3.04,2.68.4,5.07,2.4,5.93,4.97,3.32-1.45,7.33-1.18,10.42.7,3.09,1.88,5.18,5.32,5.42,8.93-19.62.81-39.23,1.62-58.85,2.43-2.47.1-5.31.05-6.91-1.83-5.56-6.54,9.41-16.82,14.4-18.98,3.25-1.41,26.31,1.43,22.48,6.82Z",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fdb930", "stroke-width": "0px" },
                  attrs: {
                    x: "2044.67",
                    y: "243.15",
                    width: "175.19",
                    height: "200.84",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "1948.14",
                    y: "243.15",
                    width: "96.53",
                    height: "200.84",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#262e6c", "stroke-width": "0px" },
                  attrs: {
                    x: "1928.07",
                    y: "228.43",
                    width: "305.25",
                    height: "14.71",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2064.6",
                    y: "301.07",
                    width: "60.56",
                    height: "142.92",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "2071.71",
                    y: "306.49",
                    width: "53.45",
                    height: "137.5",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2138.1",
                    y: "301.07",
                    width: "60.56",
                    height: "142.92",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "2145.2",
                    y: "306.49",
                    width: "53.45",
                    height: "137.5",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    x: "2112.06",
                    y: "367.56",
                    width: "10.04",
                    height: "5.22",
                    rx: "1.9",
                    ry: "1.9",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c62a53", "stroke-width": "0px" },
                  attrs: {
                    x: "2183.78",
                    y: "367.56",
                    width: "10.04",
                    height: "5.22",
                    rx: "1.9",
                    ry: "1.9",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2079.06",
                    y: "386.51",
                    width: "38.75",
                    height: "2.79",
                    rx: "1.01",
                    ry: "1.01",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2079.06",
                    y: "392.09",
                    width: "38.75",
                    height: "2.79",
                    rx: "1.01",
                    ry: "1.01",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2079.06",
                    y: "397.66",
                    width: "38.75",
                    height: "2.79",
                    rx: "1.01",
                    ry: "1.01",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2079.06",
                    y: "403.24",
                    width: "38.75",
                    height: "2.79",
                    rx: "1.01",
                    ry: "1.01",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2079.06",
                    y: "408.81",
                    width: "38.75",
                    height: "2.79",
                    rx: "1.01",
                    ry: "1.01",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2079.06",
                    y: "414.39",
                    width: "38.75",
                    height: "2.79",
                    rx: "1.01",
                    ry: "1.01",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2079.06",
                    y: "419.96",
                    width: "38.75",
                    height: "2.79",
                    rx: "1.01",
                    ry: "1.01",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2079.06",
                    y: "425.54",
                    width: "38.75",
                    height: "2.79",
                    rx: "1.01",
                    ry: "1.01",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2152.56",
                    y: "386.51",
                    width: "38.75",
                    height: "2.79",
                    rx: "1.01",
                    ry: "1.01",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2152.56",
                    y: "392.09",
                    width: "38.75",
                    height: "2.79",
                    rx: "1.01",
                    ry: "1.01",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2152.56",
                    y: "397.66",
                    width: "38.75",
                    height: "2.79",
                    rx: "1.01",
                    ry: "1.01",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2152.56",
                    y: "403.24",
                    width: "38.75",
                    height: "2.79",
                    rx: "1.01",
                    ry: "1.01",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2152.56",
                    y: "408.81",
                    width: "38.75",
                    height: "2.79",
                    rx: "1.01",
                    ry: "1.01",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2152.56",
                    y: "414.39",
                    width: "38.75",
                    height: "2.79",
                    rx: "1.01",
                    ry: "1.01",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2152.56",
                    y: "419.96",
                    width: "38.75",
                    height: "2.79",
                    rx: "1.01",
                    ry: "1.01",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "2152.56",
                    y: "425.54",
                    width: "38.75",
                    height: "2.79",
                    rx: "1.01",
                    ry: "1.01",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "2079.06",
                    y: "271.38",
                    width: "33",
                    height: "7.11",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#fc9732", "stroke-width": "0px" },
                  attrs: {
                    x: "2155.43",
                    y: "271.38",
                    width: "33",
                    height: "7.11",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#fdb930", "stroke-width": "0px" },
                  attrs: {
                    d: "m1986.18,366.21c2.95-8.18,5.9-16.37,8.96-24.89-6.37-1.69-12.5-3.32-19.04-5.06,11.01-11.48,21.76-22.69,32.52-33.9.2.1-6.99,16.91-10.94,25.56,6.4,1.69,12.51,3.31,19.03,5.04-10.23,11.53-20.09,22.65-29.95,33.78-.19-.18-.39-.35-.58-.53Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#a6adb2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1137.95,413.12h-.05c.03.11.05.22.05.33,0,1.6-3.18,3-7.91,3.74-2.24.35-4.82.55-7.58.55-8.55,0-15.48-1.92-15.48-4.28,0-.11.02-.22.05-.33h-.05V3.95h30.97v409.17Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#838a8e", "stroke-width": "0px" },
                  attrs: {
                    d: "m1137.95,413.12h-.05c.03.11.05.22.05.33,0,1.6-3.18,3-7.91,3.74V3.95h7.91v409.17Z",
                  },
                }),
                _c("ellipse", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: { cx: "1122.47", cy: "4.28", rx: "15.48", ry: "4.28" },
                }),
                _c("rect", {
                  staticStyle: { fill: "#646a6d", "stroke-width": "0px" },
                  attrs: {
                    x: "1033.19",
                    y: "53.37",
                    width: "179.22",
                    height: "17.13",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#838a8e", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "1212.41 53.37 1033.19 53.37 1046.44 43.49 1199.16 43.49 1212.41 53.37",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1158.58,29.08v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1158.58,29.08v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1158.58,36.11v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1158.58,36.11v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1158.58,43.14v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1158.58,43.14v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1176.84,29.08v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1176.84,29.08v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1176.84,36.11v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1176.84,36.11v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1176.84,43.14v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1176.84,43.14v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1193.96,29.08v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1193.96,29.08v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1193.96,36.11v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1193.96,36.11v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1193.96,43.14v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1193.96,43.14v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1063.7,29.08v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1063.7,29.08v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1063.7,36.11v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1063.7,36.11v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1063.7,43.14v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1063.7,43.14v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1081.96,29.08v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1081.96,29.08v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1081.96,36.11v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1081.96,36.11v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1081.96,43.14v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1081.96,43.14v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1099.08,29.08v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1099.08,29.08v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1099.08,36.11v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1099.08,36.11v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1099.08,43.14v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1099.08,43.14v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#646a6d", "stroke-width": "0px" },
                  attrs: {
                    x: "1033.19",
                    y: "136.39",
                    width: "179.22",
                    height: "17.13",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#838a8e", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "1212.41 136.39 1033.19 136.39 1046.44 126.51 1199.16 126.51 1212.41 136.39",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1158.58,112.1v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1158.58,112.1v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1158.58,119.13v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1158.58,119.13v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1158.58,126.16v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1158.58,126.16v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1176.84,112.1v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1176.84,112.1v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1176.84,119.13v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1176.84,119.13v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1176.84,126.16v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1176.84,126.16v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1193.96,112.1v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1193.96,112.1v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1193.96,119.13v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1193.96,119.13v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1193.96,126.16v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1193.96,126.16v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1063.7,112.1v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1063.7,112.1v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1063.7,119.13v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1063.7,119.13v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1063.7,126.16v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1063.7,126.16v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1081.96,112.1v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1081.96,112.1v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1081.96,119.13v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1081.96,119.13v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1081.96,126.16v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1081.96,126.16v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1099.08,112.1v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1099.08,112.1v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1099.08,119.13v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1099.08,119.13v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1099.08,126.16v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1099.08,126.16v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "1081.58",
                    y: "172.96",
                    width: "60.9",
                    height: "70.91",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c66312", "stroke-width": "0px" },
                  attrs: {
                    x: "1140.81",
                    y: "172.96",
                    width: "13.35",
                    height: "70.91",
                  },
                }),
                _c("circle", {
                  staticStyle: { fill: "#fff", "stroke-width": "0px" },
                  attrs: { cx: "1112.35", cy: "208.1", r: "14.28" },
                }),
                _c("path", {
                  staticStyle: { fill: "#fdb930", "stroke-width": "0px" },
                  attrs: {
                    d: "m1110.76,209.71c-1.16.13-2.12.24-3.3.37,1.95-1.81,3.75-3.49,5.69-5.3-1.26-.08-2.32-.15-3.62-.23,3.24-2.59,6.31-5.05,9.37-7.5.04.03.08.07.12.1-1.16,1.65-2.33,3.29-3.6,5.09h3.61c.02.06.05.13.07.19-1.6,1.43-3.2,2.86-5,4.47h3.52c.03.08.05.16.08.23-3.94,3.29-7.89,6.58-11.83,9.87-.04-.04-.08-.07-.12-.11,1.63-2.35,3.26-4.7,4.99-7.2Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#a6adb2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1751.54,413.12h-.05c.03.11.05.22.05.33,0,1.6-3.18,3-7.91,3.74-2.24.35-4.82.55-7.58.55-8.55,0-15.48-1.92-15.48-4.28,0-.11.02-.22.05-.33h-.05V3.95h30.97v409.17Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#838a8e", "stroke-width": "0px" },
                  attrs: {
                    d: "m1751.54,413.12h-.05c.03.11.05.22.05.33,0,1.6-3.18,3-7.91,3.74V3.95h7.91v409.17Z",
                  },
                }),
                _c("ellipse", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: { cx: "1736.05", cy: "4.28", rx: "15.48", ry: "4.28" },
                }),
                _c("rect", {
                  staticStyle: { fill: "#646a6d", "stroke-width": "0px" },
                  attrs: {
                    x: "1646.77",
                    y: "53.37",
                    width: "179.22",
                    height: "17.13",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#838a8e", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "1825.99 53.37 1646.77 53.37 1660.02 43.49 1812.74 43.49 1825.99 53.37",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1772.16,29.08v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1772.16,29.08v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1772.16,36.11v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1772.16,36.11v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1772.16,43.14v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1772.16,43.14v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1790.42,29.08v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1790.42,29.08v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1790.42,36.11v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1790.42,36.11v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1790.42,43.14v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1790.42,43.14v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1807.54,29.08v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1807.54,29.08v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1807.54,36.11v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1807.54,36.11v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1807.54,43.14v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1807.54,43.14v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1677.28,29.08v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1677.28,29.08v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1677.28,36.11v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1677.28,36.11v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1677.28,43.14v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1677.28,43.14v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1695.54,29.08v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1695.54,29.08v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1695.54,36.11v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1695.54,36.11v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1695.54,43.14v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1695.54,43.14v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1712.66,29.08v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1712.66,29.08v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1712.66,36.11v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1712.66,36.11v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1712.66,43.14v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1712.66,43.14v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#646a6d", "stroke-width": "0px" },
                  attrs: {
                    x: "1646.77",
                    y: "136.39",
                    width: "179.22",
                    height: "17.13",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#838a8e", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "1825.99 136.39 1646.77 136.39 1660.02 126.51 1812.74 126.51 1825.99 136.39",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1772.16,112.1v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1772.16,112.1v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1772.16,119.13v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1772.16,119.13v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1772.16,126.16v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1772.16,126.16v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1790.42,112.1v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1790.42,112.1v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1790.42,119.13v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1790.42,119.13v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1790.42,126.16v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1790.42,126.16v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1807.54,112.1v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1807.54,112.1v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1807.54,119.13v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1807.54,119.13v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1807.54,126.16v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1807.54,126.16v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1677.28,112.1v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1677.28,112.1v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1677.28,119.13v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1677.28,119.13v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1677.28,126.16v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1677.28,126.16v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1695.54,112.1v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1695.54,112.1v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1695.54,119.13v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1695.54,119.13v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1695.54,126.16v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1695.54,126.16v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1712.66,112.1v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1712.66,112.1v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1712.66,119.13v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1712.66,119.13v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m1712.66,126.16v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m1712.66,126.16v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "1695.16",
                    y: "172.96",
                    width: "60.9",
                    height: "70.91",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c66312", "stroke-width": "0px" },
                  attrs: {
                    x: "1754.39",
                    y: "172.96",
                    width: "13.35",
                    height: "70.91",
                  },
                }),
                _c("circle", {
                  staticStyle: { fill: "#fff", "stroke-width": "0px" },
                  attrs: { cx: "1725.93", cy: "208.1", r: "14.28" },
                }),
                _c("path", {
                  staticStyle: { fill: "#fdb930", "stroke-width": "0px" },
                  attrs: {
                    d: "m1724.34,209.71c-1.16.13-2.12.24-3.3.37,1.95-1.81,3.75-3.49,5.69-5.3-1.26-.08-2.32-.15-3.62-.23,3.24-2.59,6.31-5.05,9.37-7.5.04.03.08.07.12.1-1.16,1.65-2.33,3.29-3.6,5.09h3.61c.02.06.05.13.07.19-1.6,1.43-3.2,2.86-5,4.47h3.52c.03.08.05.16.08.23-3.94,3.29-7.89,6.58-11.83,9.87-.04-.04-.08-.07-.12-.11,1.63-2.35,3.26-4.7,4.99-7.2Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#a6adb2", "stroke-width": "0px" },
                  attrs: {
                    d: "m525.76,416.5h-.05c.03.11.05.22.05.33,0,1.6-3.18,3-7.91,3.74-2.24.35-4.82.55-7.58.55-8.55,0-15.48-1.92-15.48-4.28,0-.11.02-.22.05-.33h-.05V7.33h30.97v409.17Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#838a8e", "stroke-width": "0px" },
                  attrs: {
                    d: "m525.76,416.5h-.05c.03.11.05.22.05.33,0,1.6-3.18,3-7.91,3.74V7.33h7.91v409.17Z",
                  },
                }),
                _c("ellipse", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: { cx: "510.28", cy: "7.66", rx: "15.48", ry: "4.28" },
                }),
                _c("rect", {
                  staticStyle: { fill: "#646a6d", "stroke-width": "0px" },
                  attrs: {
                    x: "421",
                    y: "56.74",
                    width: "179.22",
                    height: "17.13",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#838a8e", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "600.21 56.74 421 56.74 434.24 46.86 586.97 46.86 600.21 56.74",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m546.38,32.46v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m546.38,32.46v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m546.38,39.48v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m546.38,39.48v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m546.38,46.51v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m546.38,46.51v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m564.65,32.46v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m564.65,32.46v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m564.65,39.48v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m564.65,39.48v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m564.65,46.51v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m564.65,46.51v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m581.77,32.46v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m581.77,32.46v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m581.77,39.48v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m581.77,39.48v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m581.77,46.51v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m581.77,46.51v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m451.5,32.46v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m451.5,32.46v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m451.5,39.48v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m451.5,39.48v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m451.5,46.51v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m451.5,46.51v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m469.77,32.46v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m469.77,32.46v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m469.77,39.48v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m469.77,39.48v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m469.77,46.51v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m469.77,46.51v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m486.89,32.46v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m486.89,32.46v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m486.89,39.48v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m486.89,39.48v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m486.89,46.51v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m486.89,46.51v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#646a6d", "stroke-width": "0px" },
                  attrs: {
                    x: "421",
                    y: "139.76",
                    width: "179.22",
                    height: "17.13",
                  },
                }),
                _c("polygon", {
                  staticStyle: { fill: "#838a8e", "stroke-width": "0px" },
                  attrs: {
                    points:
                      "600.21 139.76 421 139.76 434.24 129.88 586.97 129.88 600.21 139.76",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m546.38,115.48v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m546.38,115.48v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m546.38,122.5v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m546.38,122.5v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m546.38,129.53v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m546.38,129.53v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m564.65,115.48v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m564.65,115.48v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m564.65,122.5v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m564.65,122.5v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m564.65,129.53v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m564.65,129.53v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m581.77,115.48v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m581.77,115.48v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m581.77,122.5v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m581.77,122.5v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m581.77,129.53v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m581.77,129.53v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m451.5,115.48v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m451.5,115.48v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m451.5,122.5v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m451.5,122.5v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m451.5,129.53v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m451.5,129.53v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m469.77,115.48v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m469.77,115.48v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m469.77,122.5v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m469.77,122.5v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m469.77,129.53v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m469.77,129.53v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m486.89,115.48v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m486.89,115.48v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m486.89,122.5v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m486.89,122.5v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#bdc8d1", "stroke-width": "0px" },
                  attrs: {
                    d: "m486.89,129.53v2.89c0,.27-.06.53-.15.77-.32.76-1.1,1.3-2.01,1.3h-9.05c-.91,0-1.69-.54-2.01-1.3-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#d3dbe2", "stroke-width": "0px" },
                  attrs: {
                    d: "m486.89,129.53v2.89c0,.27-.06.53-.15.77-.38.22-.82.35-1.3.35h-10.47c-.48,0-.92-.13-1.3-.35-.1-.24-.15-.5-.15-.77v-2.89c0-1.14.97-2.07,2.16-2.07h9.05c1.19,0,2.16.93,2.16,2.07Z",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#ea882f", "stroke-width": "0px" },
                  attrs: {
                    x: "469.38",
                    y: "176.34",
                    width: "60.9",
                    height: "70.91",
                  },
                }),
                _c("rect", {
                  staticStyle: { fill: "#c66312", "stroke-width": "0px" },
                  attrs: {
                    x: "528.62",
                    y: "176.34",
                    width: "13.35",
                    height: "70.91",
                  },
                }),
                _c("circle", {
                  staticStyle: { fill: "#fff", "stroke-width": "0px" },
                  attrs: { cx: "500.16", cy: "211.47", r: "14.28" },
                }),
                _c("path", {
                  staticStyle: { fill: "#fdb930", "stroke-width": "0px" },
                  attrs: {
                    d: "m498.57,213.09c-1.16.13-2.12.24-3.3.37,1.95-1.81,3.75-3.49,5.69-5.3-1.26-.08-2.32-.15-3.62-.23,3.24-2.59,6.31-5.05,9.37-7.5.04.03.08.07.12.1-1.16,1.65-2.33,3.29-3.6,5.09h3.61c.02.06.05.13.07.19-1.6,1.43-3.2,2.86-5,4.47h3.52c.03.08.05.16.08.23-3.94,3.29-7.89,6.58-11.83,9.87-.04-.04-.08-.07-.12-.11,1.63-2.35,3.26-4.7,4.99-7.2Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#262e6c", "stroke-width": "0px" },
                  attrs: {
                    d: "m580.31,50.52c122.57,56.09,251.09,75.84,382.99,43.29,42.47-10.26,83.79-25.26,123.86-43.29-45.79,24.94-95.29,44.04-146.44,55.26-122.46,27.77-251.06,4.89-360.4-55.26h0Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#262e6c", "stroke-width": "0px" },
                  attrs: {
                    d: "m557.96,50.52c123.53,56.1,253.01,75.8,385.8,43.29,42.79-10.25,84.43-25.25,124.82-43.29-46.19,24.98-96.07,44.07-147.59,55.28-123.23,27.74-252.84,4.91-363.04-55.28h0Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#262e6c", "stroke-width": "0px" },
                  attrs: {
                    d: "m536.59,50.52c107.28,48.07,226.84,71.09,343.68,52.77,61.09-9.06,120.09-27.9,176.73-52.77-39.78,21.11-82.02,37.93-125.79,49.43-133.8,35.91-273.1,15.43-394.63-49.43h0Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#262e6c", "stroke-width": "0px" },
                  attrs: {
                    d: "m2288.08,63.96v2.54c-36.67,17.19-75.28,30.59-114.88,39.28-38.14,8.65-76.87,12.38-115.43,11.61-2.76-.05-5.53-.13-8.29-.24-32.9-1.2-65.64-5.68-97.73-13.16-13.8-3.22-27.48-7-41-11.32-29.11-9.28-57.49-21.06-84.76-35.13-2.66-1.36-5.31-2.75-7.95-4.17-1.75-.94-3.5-1.89-5.25-2.85,2.1.96,4.2,1.91,6.3,2.85,2.3,1.03,4.6,2.04,6.9,3.04,72.82,31.66,147.71,50.37,224.12,52.83,2.26.08,4.53.13,6.8.18,32.27.63,64.8-1.65,97.57-7.09,13.73-2.28,27.5-5.11,41.3-8.52,4.74-1.15,9.47-2.35,14.19-3.62,26.5-7.09,52.55-15.97,78.11-26.23Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#262e6c", "stroke-width": "0px" },
                  attrs: {
                    d: "m2288.08,56.19v1.15c-25.13,12.8-51.28,23.85-78.11,32.85-18.54,6.22-37.41,11.46-56.5,15.61-31.62,7.12-63.67,10.91-95.7,11.59-6.25.13-12.5.15-18.74.04-54.15-.88-108.01-10.54-159.47-27.88-18.19-6.13-36.08-13.22-53.57-21.22-10.23-4.68-20.32-9.66-30.25-14.96-1.77-.94-3.54-1.89-5.3-2.85,2.12.96,4.23,1.91,6.35,2.85,9.7,4.3,19.43,8.37,29.2,12.21,27.97,11,56.24,20.09,84.76,27.09,42.9,10.53,86.39,16.34,130.35,16.8,5.26.06,10.53.04,15.81-.05,39.42-.73,79.23-5.79,119.33-15.61,16.64-3.99,33.1-8.69,49.39-14.01,21.13-6.9,41.95-14.84,62.45-23.61Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#262e6c", "stroke-width": "0px" },
                  attrs: {
                    d: "m2288.08,51.13v.13c-20.21,10.67-41.06,20.22-62.42,28.53-.01.01-.02.01-.03.01-20.22,7.87-40.89,14.62-61.93,20.15-3.07.82-6.14,1.62-9.22,2.38h-.01c-34.8,8.66-69.93,13.53-104.99,14.82-3.46.13-6.92.23-10.38.28-.02.01-.05.01-.07,0-78.34,1.33-156.11-15.1-228.77-46.93-12.07-5.28-24.01-11-35.78-17.13-1.81-.94-3.61-1.89-5.41-2.85,2.14.96,4.29,1.91,6.44,2.85,14.1,6.16,28.4,11.88,42.88,17.13,20.09,7.29,40.51,13.67,61.17,19.05,0,0,.01.01.02.01,23.77,6.19,47.86,11.04,72.13,14.42.01,0,.03,0,.04,0,29.59,4.12,59.46,6.04,89.35,5.48.07.01.14.01.22,0,2.91-.05,5.83-.13,8.75-.23h.04c20.91-.73,41.82-2.68,62.65-5.95,60.58-8.98,119.11-27.59,175.32-52.16Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#262e6c", "stroke-width": "0px" },
                  attrs: {
                    d: "m479.51,50.52c-.59.32-1.19.64-1.78.96-3.31,1.79-6.63,3.55-9.98,5.27-11.85,6.12-23.93,11.84-36.21,17.13-13.3,5.74-26.83,10.97-40.54,15.65-18.99,6.5-38.34,11.95-57.93,16.25-15.59,3.53-31.27,6.25-47.01,8.17-1.17.14-2.34.28-3.51.41-3.98.46-7.96.87-11.94,1.22-3.68.33-7.36.61-11.04.86-.16,0-.33.02-.5.03-3.44.22-6.88.41-10.32.56-3.57.15-7.14.27-10.71.35-3.62.08-7.23.11-10.84.11-3.19,0-6.37-.04-9.56-.1l-2.61-.06c-1.89-.05-3.78-.1-5.68-.18-32.9-1.2-65.64-5.68-97.73-13.16-13.8-3.22-27.48-7-41-11.32-24.11-7.69-47.72-17.09-70.62-28.08v-2.21c68.37,28.04,138.51,44.56,209.98,46.86,2.27.08,4.53.13,6.81.18,1.58.03,3.16.05,4.74.06,4,.05,8,.05,12.01,0,6.5-.07,13.01-.27,19.53-.59.22-.01.44-.02.66-.03,3.58-.18,7.17-.39,10.76-.65,16.56-1.16,33.18-3.11,49.86-5.88,13.73-2.28,27.5-5.11,41.3-8.52,4.74-1.15,9.47-2.35,14.19-3.62.82-.21,1.64-.43,2.46-.66,16.7-4.54,33.22-9.79,49.56-15.65,14.64-5.25,29.13-10.98,43.47-17.13,4.02-1.72,8.03-3.48,12.03-5.27.72-.32,1.43-.64,2.15-.96Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#262e6c", "stroke-width": "0px" },
                  attrs: {
                    d: "m460.94,50.52c-.6.32-1.2.65-1.8.96-3.33,1.79-6.67,3.55-10.04,5.27-9.24,4.73-18.61,9.23-28.1,13.47-16.08,7.18-32.5,13.64-49.2,19.31-.65.22-1.31.44-1.96.66-18.53,6.22-37.4,11.46-56.49,15.61-14.72,3.31-29.53,5.9-44.39,7.8-3.54.45-7.08.86-10.63,1.23-.17.02-.34.04-.51.05-3.35.35-6.71.67-10.07.94-2.99.25-5.98.47-8.97.66-3.75.25-7.51.44-11.26.6-3.29.13-6.59.24-9.88.31-.9.02-1.8.03-2.7.05-5.35.08-10.69.08-16.04-.01-54.14-.88-108-10.54-159.46-27.88-13.32-4.48-26.48-9.49-39.44-14.99v-3.59c23.35,8.61,46.9,15.88,70.62,21.7,42.9,10.53,86.39,16.34,130.35,16.8,5.26.06,10.54.04,15.82-.05,1.63-.03,3.26-.07,4.89-.12,4.12-.11,8.25-.27,12.38-.48,5.99-.3,11.99-.71,18-1.22.22-.01.44-.03.66-.05,3.46-.3,6.93-.63,10.4-1,24.21-2.54,48.55-6.75,73-12.74,5.62-1.35,11.21-2.77,16.79-4.28,10.96-2.96,21.84-6.22,32.65-9.75,11.91-3.89,23.73-8.11,35.44-12.63,8.6-3.32,17.15-6.79,25.64-10.4,4.06-1.72,8.1-3.48,12.13-5.27.72-.32,1.45-.64,2.17-.96Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#262e6c", "stroke-width": "0px" },
                  attrs: {
                    d: "m449.36,50.52c-.6.32-1.21.64-1.82.96-3.39,1.79-6.8,3.54-10.23,5.27-5.39,2.71-10.83,5.34-16.31,7.89-11.63,5.42-23.46,10.48-35.44,15.14-8.92,3.47-17.92,6.73-27.01,9.75-11.54,3.85-23.2,7.33-34.98,10.42-3.07.82-6.14,1.62-9.22,2.38-15.59,3.88-31.26,7-46.96,9.37-3.45.53-6.89,1.02-10.35,1.46-.17.03-.35.05-.53.07-3.3.43-6.61.83-9.92,1.19-2.22.25-4.45.48-6.68.69-3.87.38-7.75.71-11.62,1-4.3.31-8.6.58-12.9.78-2.02.1-4.03.19-6.04.26-3.48.13-6.97.23-10.45.28-67.7,1.15-134.98-10.97-198.9-34.82v-4.62c13.03,4.25,26.19,8.12,39.44,11.56,23.79,6.2,47.89,11.06,72.18,14.44,29.6,4.12,59.46,6.04,89.35,5.48,3-.05,6-.13,9.01-.23,4.07-.14,8.14-.33,12.22-.57,4.22-.24,8.45-.54,12.68-.89,5.36-.43,10.72-.96,16.08-1.57.22-.02.44-.04.67-.07,3.37-.39,6.73-.81,10.1-1.26,3.64-.49,7.27-1.02,10.9-1.59,22.44-3.33,44.6-7.97,66.46-13.76,27.79-7.34,55.1-16.52,81.91-27.16,4.62-1.82,9.22-3.7,13.8-5.62,4.13-1.72,8.25-3.47,12.35-5.27.74-.32,1.47-.64,2.21-.96Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#262e6c", "stroke-width": "0px" },
                  attrs: {
                    d: "m1192.47,50.52c122.57,56.09,251.09,75.84,382.99,43.29,42.47-10.26,83.79-25.26,123.86-43.29-45.79,24.94-95.29,44.04-146.44,55.26-122.46,27.77-251.06,4.89-360.4-55.26h0Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#262e6c", "stroke-width": "0px" },
                  attrs: {
                    d: "m1170.12,50.52c123.53,56.1,253.01,75.8,385.8,43.29,42.79-10.25,84.43-25.25,124.82-43.29-46.19,24.98-96.07,44.07-147.59,55.28-123.23,27.74-252.84,4.91-363.04-55.28h0Z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#262e6c", "stroke-width": "0px" },
                  attrs: {
                    d: "m1148.75,50.52c107.28,48.07,226.84,71.09,343.68,52.77,61.09-9.06,120.09-27.9,176.73-52.77-39.78,21.11-82.02,37.93-125.79,49.43-133.8,35.91-273.1,15.43-394.63-49.43h0Z",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: { x1: "196.83", y1: "363", x2: "219.97", y2: "363" },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "64.78",
                    y1: "273.71",
                    x2: "87.92",
                    y2: "273.71",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "360.16",
                    y1: "430.18",
                    x2: "383.3",
                    y2: "430.18",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "789.57",
                    y1: "421.28",
                    x2: "812.7",
                    y2: "421.28",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "688",
                    y1: "245.76",
                    x2: "711.14",
                    y2: "245.76",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "1607.85",
                    y1: "422.8",
                    x2: "1630.99",
                    y2: "422.8",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "1334.18",
                    y1: "375.85",
                    x2: "1357.32",
                    y2: "375.85",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "1135.7",
                    y1: "355.42",
                    x2: "1158.84",
                    y2: "355.42",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "1425.02",
                    y1: "409.28",
                    x2: "1448.16",
                    y2: "409.28",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "1898",
                    y1: "282.48",
                    x2: "1921.14",
                    y2: "282.48",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "1872.86",
                    y1: "383.35",
                    x2: "1896",
                    y2: "383.35",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "1675.09",
                    y1: "375.85",
                    x2: "1681.96",
                    y2: "375.85",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "1693.66",
                    y1: "412.96",
                    x2: "1700.53",
                    y2: "412.96",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "1740.61",
                    y1: "309.55",
                    x2: "1747.48",
                    y2: "309.55",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "2255.33",
                    y1: "237.01",
                    x2: "2262.2",
                    y2: "237.01",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "1014.59",
                    y1: "400.67",
                    x2: "1021.46",
                    y2: "400.67",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "1133.9",
                    y1: "443.99",
                    x2: "1140.77",
                    y2: "443.99",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "239.67",
                    y1: "383.35",
                    x2: "246.54",
                    y2: "383.35",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: { x1: "117.29", y1: "363", x2: "124.16", y2: "363" },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "897.89",
                    y1: "430.18",
                    x2: "904.76",
                    y2: "430.18",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "680.35",
                    y1: "277.67",
                    x2: "687.23",
                    y2: "277.67",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "876.94",
                    y1: "383.35",
                    x2: "883.81",
                    y2: "383.35",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "449.22",
                    y1: "383.35",
                    x2: "456.09",
                    y2: "383.35",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "120.72",
                    y1: "424.66",
                    x2: "127.59",
                    y2: "424.66",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "683.79",
                    y1: "400.67",
                    x2: "690.66",
                    y2: "400.67",
                  },
                }),
                _c("line", {
                  staticStyle: {
                    fill: "none",
                    stroke: "#04b776",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "8px",
                  },
                  attrs: {
                    x1: "2247.19",
                    y1: "347.46",
                    x2: "2270.33",
                    y2: "347.46",
                  },
                }),
              ]),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }